<template>
  <div class="play-icon">
    <img :src="img[count]" class="img">
  </div>
</template>

<script>
export default {
  name: 'PlayIcon',
  data() {
    return {
      count: 0,
      img: [
        require('@/assets/audio/audio-3.png'),
        require('@/assets/audio/audio-2.png'),
        require('@/assets/audio/audio-1.png')
      ]
    }
  },
  mounted() {
    this.handlePlayVoice()
  },
  methods: {
    handlePlayVoice() {
      setInterval(() => {
        this.count++
        if (this.count > 2) {
          this.count = 0
        }
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
.play-icon {
  display: none;
  padding: 0;
  margin: 0;
  .img {
    height: 12px;
    width: 12px;
  }
}

</style>
